<template>
  <div class="flex items-center cursor-pointer">
    <div class="flex items-center flex-shrink-0">
      <div class="mr-10 flex rounded-6 cursor-pointer border bg-primary"
           :class="[{'bg-grey-580': isOutlined && isDarkMode}, isDarkMode ? 'border-project' : 'border-grey-580', size]"
      >
        <img
          v-if="teamLogo"
          class="max-h-2/3 max-w-2/3 w-full h-full object-contain p-2"
          :src="teamLogo"
          alt="teamLogo"
        >
        <img v-else class="w-2/3 h-2/3 m-auto" :src="iconSRC" alt="icon">
      </div>
    </div>
    <span class="text-app-color truncate w-full">{{ book?.title }}</span>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'BookLabel',

  props: {
    book: Object,
    size: { type: String, default: 'w-30 h-30' }
  },

  setup (props) {
    const { getters, state } = useStore()

    const isDarkMode = computed(() => getters.isDarkMode)

    const teamLogo = computed(() => {
      if (props.book?.isHeadquarters && state.team.team?.teamLogo?.url) return state.team.team?.teamLogo?.url
      return null
    })

    const iconSRC = computed(() => {
      const icon = props.book?.icon || 'default-phoenix'

      if (icon.includes('default-')) {
        return require(`@/assets/images/book-icons/${icon}.svg`)
      }

      return require(`@/assets/images/icons/${icon}.png`)
    })

    const isOutlined = computed(() => props.book?.icon?.includes('outlined'))

    return {
      // ref
      // data
      // computed
      teamLogo,
      iconSRC,
      isDarkMode,
      isOutlined
      // function
    }
  }
})
</script>
